import { Component, OnDestroy, OnInit } from "@angular/core";
import { MatDialog, MatDialogRef } from "@angular/material/dialog";
import { Subject } from "rxjs";
import { HelpBoxComponent } from "@bitwarden/web-vault/app/gloss/help-box/help-box.component";
import { I18nService } from "@bitwarden/common/abstractions/i18n.service";
import { ActionButton } from "@bitwarden/web-vault/app/components/buttons/gloss-button/actionButton";
import { RoleAccessData } from "@bitwarden/web-vault/app/models/data/role-access.data";

@Component({
  selector: "app-user-access-page",
  templateUrl: "user-access-page.component.html",
})
export class UserAccessPageComponent implements OnInit, OnDestroy {
  private destroy$ = new Subject<void>();
  private roleAccess: RoleAccessData;

  earlyAccessDialog: MatDialogRef<HelpBoxComponent>;
  isPremiumUser = false;
  requestAccessButtonOptions: ActionButton;

  constructor(
    public dialog: MatDialog,
    private i18nService: I18nService,
  ) {
    this.requestAccessButtonOptions = new ActionButton({
      text: this.i18nService.t("requestAccess"),
      class: "primary",
      icon: "link",
      onClick: this.requestEarlyAccess.bind(this),
    });
  }

  ngOnInit() {
    this.checkRoleAccess();
  }

  ngOnDestroy() {
    this.destroy$.next();
    this.destroy$.complete();
  }

  checkRoleAccess() {
    if (this.roleAccess) {
      const claim = this.roleAccess.getClaim();
      this.isPremiumUser =
        claim.gloss_subscription_tier === "premium" ||
        claim.gloss_subscription_tier === "enterprise";
    }
  }

  requestEarlyAccess = async () => {
    this.earlyAccessDialog = this.dialog.open(HelpBoxComponent, {
      maxWidth: "100vw",
      maxHeight: "100vh",
      data: {
        supportBoxHeader: this.i18nService.t("requestEarlyAccess"),
        textFieldMessage: this.i18nService.t("earlyAccessDefaultMessage"),
        dialogOpen: true,
        closeDialog: this.closeEarlyAccess.bind(this),
      },
      disableClose: true,
    });
  };

  closeEarlyAccess() {
    this.earlyAccessDialog.close();
  }
}
